import { User } from "../../../domain/user";
import { IUserBean } from "../beans";

export class UserTranslator {
  static toUser(bean: IUserBean): User {
    if (!bean) { throw new Error("bean is empty!!!"); }
    return new User(bean.code, bean.name);
  }
}
